import { toast } from "react-toastify";
import { endpoints } from "../../../../configs/Settings";
import { HTTPResponseStatus } from "../../../../utils/enum";

import { useAuth } from "../../../../utils/useAuth";
import { useAxios } from "../../../../utils/useAxios";

export async function PutCondition(objData: any, id: number) {
  let url = `${endpoints.EHRPOSTER}/Condition/${id}`;

  const data = objData;
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, data, { headers, timeout: 8000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PutCondition: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PutCondition ", error);
      // toast.error(`PutCondition Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
